// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

var navigationOppened = false
var backdrop = $('<div id="backdrop-navigation" class="visible">')

var toggleNavigation = function() {
  console.log(navigationOppened)
  if (!navigationOppened) {
    navigationOppened = true
    $('body').append(backdrop);
    $('.navigation-container').toggleClass('show-mobile-menu')
    $('#navbar-button-open').removeClass('open').addClass('close')
  } else {
    navigationOppened = false
    $('.navigation-container').toggleClass('show-mobile-menu')
    $('#navbar-button-open').removeClass('close').addClass('open')
    $('#backdrop-navigation').removeClass('visible').addClass('invisible')
    setTimeout(function() {
      $('#backdrop-navigation').remove()
    }, 300)
  }

}
$('.navbar-button').on('click', toggleNavigation)
backdrop.on('click', toggleNavigation);



// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js